import { UserState } from './types'
import { defineState } from '../../../base/store/defineState'

export const defaultState = (): UserState => ({})

export const resetUserState = () => {
  return defaultState()
}

export default defineState<UserState>('user', defaultState)
